import { DeleteOversightResultsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteOversightResults = createMutationHook({
  name: 'deleteOversightResults',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.assessment.deleteOversightResults.mutationOptions({
      onSuccess,
    }),
  mapInput: (ids: string[]) => ({ Ids: ids }),
  // Apollo parity: the delete evicts every oversight-result family, the
  // aggregates and oversight_assessment. Invalidate the migrated tRPC read
  // families that back them.
  invalidate: (trpc) => [
    trpc.frontend.assessment.getOversightResultsByParentId.pathKey(),
    trpc.frontend.assessment.getAllOversightAssessmentResults.queryKey(),
    trpc.frontend.assessment.oversightResultById.pathKey(),
    trpc.frontend.assessment.documentOversightResultById.pathKey(),
    trpc.frontend.assessment.obligationOversightResultById.pathKey(),
    trpc.frontend.assessment.riskOversightResultById.pathKey(),
    trpc.frontend.assessment.oversightAssessmentDocumentAssessmentResultsByDocumentId.pathKey(),
    trpc.frontend.assessment.oversightAssessmentObligationAssessmentResultsByObligationId.pathKey(),
    trpc.frontend.assessment.oversightAssessmentRiskAssessmentResultsByRiskId.pathKey(),
    // Apollo parity: aggregate + oversight_assessment families.
    trpc.frontend.assessment.oversightAssessmentResultCount.queryKey(),
    trpc.frontend.assessment.oversightActivityRegister.queryKey(),
    trpc.frontend.assessment.oversightActivityCount.queryKey(),
  ],
  mapResponse: (): void => undefined,
  graphqlDocument: DeleteOversightResultsDocument,
  graphqlVariables: (ids: string[]) => ({ Ids: ids }),
  // The pre-factory hook returned `Promise<void>` from BOTH paths — it awaited
  // the Apollo mutation and returned nothing. Without this mapper the factory
  // would hand back the raw mutation document instead, so the Apollo path has
  // to opt into void explicitly to match the tRPC path.
  mapGraphqlResponse: (): void => undefined,
  evictFields: [
    'obligation_oversight_result',
    'document_oversight_result',
    'control_test_oversight_result',
    'risk_controlled_oversight_result',
    'risk_uncontrolled_oversight_result',
    'oversight_assessment',
    'obligation_oversight_result_aggregate',
    'document_oversight_result_aggregate',
    'control_test_oversight_result_aggregate',
    'risk_controlled_oversight_result_aggregate',
    'risk_uncontrolled_oversight_result_aggregate',
  ],
});
